export const chapters = [
  {
    id: 8,
    part: 1,
    englishTitle: "The Finals",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: true,
    parts: [
        {
            englishTitle: "Uchiha Sasuke vs Kinuta Dosu",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: true,
            content: `Content for Uchiha Sasuke vs Kinuta Dosu...`
        },
        {
            englishTitle: "Uzumaki Naruto vs Hyūga Neji",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: true,
            content: `Content for Uzumaki Naruto vs Hyūga Neji...`
        },
        {
            englishTitle: "Aburame Shino vs Kankurō",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Aburame Shino vs Kankurō...`
        },
        {
            englishTitle: "Temari vs Nara Shikamaru",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Temari vs Nara Shikamaru...`
        },
        {
            englishTitle: "Uchiha Sasuke vs Gaara",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Uchiha Sasuke vs Gaara...`
        }
    ]
  }
];
